'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptimizelySDK = exports.OptimizelySDKUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _decorator = require('helpers/decorator');

var _optimizely = require('./optimizely.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OptimizelySDKUnwrapped = exports.OptimizelySDKUnwrapped = function (_Component) {
  (0, _inherits3.default)(OptimizelySDKUnwrapped, _Component);

  function OptimizelySDKUnwrapped() {
    (0, _classCallCheck3.default)(this, OptimizelySDKUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (OptimizelySDKUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(OptimizelySDKUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(OptimizelySDKUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.constructor.hasInitialized) {
        this.constructor.hasInitialized = true;
        this.props.setLoading();

        // Ensure a "push" interface
        window.optimizely = window.optimizely || [];

        // Optimizely might take awhile to load.  We want to know when it finishes
        window.optimizely.push({
          type: 'addListener',
          filter: { type: 'lifecycle', name: 'initialized' },
          handler: this.props.setAvailable
        });

        // Optimizely may have loaded before the listener was in place to fire
        if (!Array.isArray(window.optimizely)) {
          this.props.setAvailable();
        }

        // Check eligibility for experiments on each page change
        document.body.addEventListener('historyChanged', function () {
          return window.optimizely.push({ type: 'activate' });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactHelmet2.default,
        null,
        _react2.default.createElement('link', { rel: 'prefetch', href: 'https://cdn.optimizely.com/js/' + (0, _universalConfig2.default)().optimizely.projectId + '.js' }),
        _react2.default.createElement('link', { rel: 'preconnect', href: '//logx.optimizely.com' })
      );
    }
  }]);
  return OptimizelySDKUnwrapped;
}(_react.Component);

OptimizelySDKUnwrapped.hasInitialized = false;
OptimizelySDKUnwrapped.propTypes = {
  setAvailable: _propTypes2.default.func.isRequired,
  setLoading: _propTypes2.default.func.isRequired
};

var OptimizelySDK = exports.OptimizelySDK = (0, _decorator.decorateWith)((0, _reactRedux.connect)(null, { setAvailable: _optimizely.setAvailable, setLoading: _optimizely.setLoading }), (0, _decorator.withName)('OptimizelySDK'))(OptimizelySDKUnwrapped);